/**
 * Utility functions for ad placement logic
 */

/**
 * Determines if an ad should be shown at a given position
 * Shows ads at every 4th position (3, 7, 11, etc.)
 */
export function shouldShowAd(index: number): boolean {
  // Show ad at positions 3, 7, 11, 15, etc. (every 4th item, 0-indexed)
  return (index + 1) % 4 === 0;
}

/**
 * Calculates the ad position number for analytics
 * First ad is position 1, second ad is position 2, etc.
 */
export function getAdPosition(index: number): number {
  return Math.floor((index + 1) / 4);
}

/**
 * Inserts ads into a list of items at appropriate positions
 * Returns a new array with ad placeholders inserted
 */
export function insertAdsIntoList<T>(
  items: T[], 
  createAdPlaceholder: (position: number) => T
): T[] {
  const result: T[] = [];
  let adPosition = 1;

  items.forEach((item, index) => {
    result.push(item);
    
    // Add ad after every 4th item
    if (shouldShowAd(index)) {
      result.push(createAdPlaceholder(adPosition));
      adPosition++;
    }
  });

  return result;
}

/**
 * Calculates total number of ads that will be shown for a given number of items
 */
export function calculateAdCount(itemCount: number): number {
  return Math.floor(itemCount / 4);
}

/**
 * Gets the indices where ads should be placed
 */
export function getAdIndices(itemCount: number): number[] {
  const indices: number[] = [];
  for (let i = 0; i < itemCount; i++) {
    if (shouldShowAd(i)) {
      indices.push(i);
    }
  }
  return indices;
}